import React, { Component } from "react";

//view
import CariAppFormViewPg4 from "../presentational/CariAppFormViewPg4";

//generic functions
import {
    isEmpty,
    cloneObject,
    copyArrObject
} from "../../../../../functions/generic_functions";

//router
import {
    withRouter,
} from 'react-router-dom';

//static routes
import {
    cari_api_load_form_page_4_url,
    cari_home_pg_url
} from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariFormPageData,
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setCariFormPageData: (page_data) => {
            dispatch(setCariFormPageData(page_data))
        },
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

class CariAppFormContainerPg4 extends Component {

    state = {
        mounted: false,
        pageLoaded: false,

        submitted: false,
        page_num: 4,
        
        staticUiData: {
            submission_instructions: "",
            direct_contact_referees_checkbox_text: ""
        },
        
        postData: { 
            /*
                values come in the format of:
                 {
                    application_lead_id: 1
                    lead_name: "Beedie Work for Us Page",
                    other_name: "",
                    checked: false,
                },
            */
            positionSourceList: [], 
            direct_contact_referees_checkbox_val: false,
        }
    }

    constructor(props) {
        super(props);

        //load page data from api
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);
    
        //action handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);

        //helper functions
        this.savePostDataToReduxStore = this.savePostDataToReduxStore.bind(this);
    }


     /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
        }
           
        return data {
            status => true/false,
            message {
                application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
                staticUiData: {
                    submission_instructions: "",
                },
                postData: {
                    positionSourceList: [
                        {
                            id: 1
                            value: "Beedie Work for Us Page",
                            other_name: "",
                            checked: false,
                        },
                        {
                            id
                            value: "Caut",
                            other_name: "",
                            checked: false,
                        },
                        {
                            id
                            value: "University Affairs",
                            other_name: "",
                            checked: false,
                        },
                        {
                            id
                            value: "SFU Webpage",
                            other_name: "",
                            checked: false,
                        },
                        {
                            id
                            value:  "Other",
                            other_name: "",
                            checked: false,
                        }
                    ],
                }
            }
        }
    */
    load_page_data_from_api() {
        
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_load_form_page_4_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
                && !isEmpty(JSON.parse(json.message).staticUiData)
            ) {
                var json_data = JSON.parse(json.message);
                var fetchedPageData = json_data;

                //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
                var fetchedSubmittedVal = false
                var fetchedApplicationStatus = null;
                if (!isEmpty(fetchedPageData.application_status)) {
                    fetchedApplicationStatus = fetchedPageData.application_status;
                    fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
                }

                //get fetched data
                var fetchedPostData = fetchedPageData.postData;
                var fetchedStaticUiData = fetchedPageData.staticUiData;

                //get a deep copy of staticUiData and postData
                var copyStaticUiData = cloneObject(this.state.staticUiData);
                var copyPostData = cloneObject(this.state.postData);

                //get post Data
                //loop through fetched page data and set the state values if they are not null, empty string or undefined
                for (let stateKey in copyPostData) {
                    let currFetchedVal = fetchedPostData[stateKey];
                    if (!isEmpty(currFetchedVal)) {
                        copyPostData[stateKey] = currFetchedVal;
                    }
                }

                //get static Ui Data
                //loop through fetched page data and set the state values if they are not null, empty string or undefined
                for (let stateKey in copyStaticUiData) {
                    let currFetchedVal = fetchedStaticUiData[stateKey];
                    if (!isEmpty(currFetchedVal)) {
                        copyStaticUiData[stateKey] = currFetchedVal;
                    }
                }

                //set page loaded to true
                this.setState({
                    pageLoaded: true,
                    postData: copyPostData,
                    staticUiData: copyStaticUiData,
                    submitted: fetchedSubmittedVal,
                }, () => {
                    
                    //get copy of post data and save to redux store
                    var reduxCopyPostData = cloneObject(this.state.postData);
                    this.savePostDataToReduxStore(reduxCopyPostData);

                    //save application status to store
                    var updatedApplicationData = this.props.activeApplicationData;
                    updatedApplicationData.application_status = fetchedApplicationStatus;
                    this.props.setCariFormActiveApplicationData(updatedApplicationData);

                    // if application submitted, they agreed the direct_contact_referees consent
                    this.state.postData['direct_contact_referees_checkbox_val'] = this.state.submitted;
                });
            }
            //if api returns no data, popup modal 
            else {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Failed to retrieve data."
                    ,
                    callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                });
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Something went wrong.",
                callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
            });
        });
    }

    savePostDataToReduxStore(reduxCopyPostData) {
        //set page num for redux post data
        reduxCopyPostData['page_num'] = this.state.page_num;
        this.props.setCariFormPageData(reduxCopyPostData);
    }

    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    //handles on change events for setting states for form input for post data
    handleOnChangeSetParentState(value, nameKey) {

        //name key will come in the form of : nameKey?id where Id is the checkbox id
        //split the string by the "?" character to extract the checkbox id, and name
        var nameKeyArr = nameKey.split("?");
        var checkBoxId = nameKeyArr[1]; //checkbox id
        nameKey = nameKeyArr[0]; //nameKey

        var copyPostData = {};
        copyPostData['direct_contact_referees_checkbox_val'] = this.state.postData.direct_contact_referees_checkbox_val;
        copyPostData['positionSourceList'] = copyArrObject(this.state.postData.positionSourceList);

        //set the value for checkboxes for positionSourceListCheckbox or
        //set the value of the positionSourceListOtherName
        if (nameKey === "positionSourceListCheckbox" 
            || nameKey === "positionSourceListOtherName"
        ) {

            for (var positionSourceIndex in copyPostData.positionSourceList) {    
                var application_lead_id = copyPostData.positionSourceList[positionSourceIndex]['id'];

                if(application_lead_id === checkBoxId) {
                    if (nameKey === "positionSourceListOtherName") {
                        copyPostData.positionSourceList[positionSourceIndex].other_name = value;
                        break;
                    }
                    else {
                        copyPostData.positionSourceList[positionSourceIndex].checked = value;
                        break;
                    }
                    
                }
            }
        } else if (nameKey === "direct_contact_referees_checkbox_val") {
            copyPostData['direct_contact_referees_checkbox_val'] = value;
        }
        
        //set data
        this.setState({
            postData: copyPostData,
        });

        //get copy of post data and save to redux store
        var reduxCopyPostData = cloneObject(copyPostData);
        this.savePostDataToReduxStore(reduxCopyPostData);
    }

    render() {
        return (
            <div>
                <CariAppFormViewPg4
                    pageLoaded={this.state.pageLoaded}
                    staticUiData={this.state.staticUiData}
                    postData={this.state.postData}
                    onChangeSetParentState={this.handleOnChangeSetParentState}
                    submitted={this.state.submitted}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormContainerPg4));